/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('region.cams')
 */
import { RegionLayout } from 'page-components/region/_layout';
import Component, { getRegionCamsPageServerSideProps } from 'page-components/region/cams';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchRegionSlugs } from 'util/fetchStaticPageRegion';
import { packPaths } from 'util/packPaths'; */

export default Object.assign(Component, { Layout: RegionLayout });

export const getServerSideProps = propsWithI18NSSR(getRegionCamsPageServerSideProps);

/* export const getStaticPaths = async () => packPaths((await fetchRegionSlugs('region.cams')).map((reg) => ({
  region: reg.slug,
}))); */
